import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const Advertisers = {
  AdvertisersList: lazyNamed(() => import('./containers/AdvertisersList/index.tsx'), 'AdvertisersList'),
  AdvertiserOverview: lazyNamed(() => import('./containers/AdvertiserOverview/index.tsx'), 'AdvertiserOverview'),
  ConversionTrackerForm: lazyNamed(() => import('./containers/ConversionTrackerForm/index.tsx'), 'ConversionTrackerForm'),
};
